import React, { useState, useRef } from "react";
import { useMondayImportItemsContext } from "../monday-import-items-context";
import styles from "./monday-breadcrumbs.module.css";
import { useOnClickOutside } from "usehooks-ts";

export function MondayBreadcrumbs() {
  const { breadcrumbs, navigateToBreadcrumb, clearBreadcrumbs, goBack } = useMondayImportItemsContext();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(dropdownRef, () => setShowDropdown(false));

  if (breadcrumbs.length === 0) {
    return null;
  }

  // If we have more than 2 levels (not counting Board), show: First / Second / ... / Last
  const shouldCollapse = breadcrumbs.length > 2;
  const collapsedItems = shouldCollapse ? breadcrumbs.slice(2, -1) : [];

  return (
    <div className={styles.breadcrumbsContainer}>
      {/* Back button */}
      <button
        className={styles.backButton}
        onClick={() => (breadcrumbs.length > 1 ? goBack() : clearBreadcrumbs())}
        title="Go back"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 12L6 8L10 4" stroke="#1e1e1e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      {/* Always show first item */}
      {breadcrumbs.length > 0 && (
        <>
          <button className={styles.breadcrumbItem} onClick={() => navigateToBreadcrumb(0)}>
            <span className={styles.breadcrumbName}>{breadcrumbs[0].name}</span>
          </button>
        </>
      )}

      {/* Show second item if exists */}
      {breadcrumbs.length > 1 && (
        <>
          <span className={styles.separator}>/</span>
          <button
            className={styles.breadcrumbItem}
            onClick={() => navigateToBreadcrumb(1)}
            disabled={breadcrumbs.length === 2}
          >
            <span className={styles.breadcrumbName}>{breadcrumbs[1].name}</span>
          </button>
        </>
      )}

      {/* Show ellipsis if more than 2 levels */}
      {shouldCollapse && collapsedItems.length > 0 && (
        <>
          <span className={styles.separator}>/</span>
          <div className={styles.ellipsisContainer} ref={dropdownRef}>
            <button className={styles.ellipsisButton} onClick={() => setShowDropdown(!showDropdown)}>
              ...
            </button>
            {showDropdown && (
              <div className={styles.dropdown}>
                {collapsedItems.map((item, index) => (
                  <button
                    key={`${item.id}-${item.level}`}
                    className={styles.dropdownItem}
                    onClick={() => {
                      navigateToBreadcrumb(index + 2);
                      setShowDropdown(false);
                    }}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </>
      )}

      {/* Always show last item if more than 2 levels */}
      {breadcrumbs.length > 2 && (
        <>
          <span className={styles.separator}>/</span>
          <button className={styles.breadcrumbItem} disabled>
            <span className={styles.breadcrumbName}>{breadcrumbs[breadcrumbs.length - 1].name}</span>
          </button>
        </>
      )}
    </div>
  );
}
